<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
    <div style="padding-top: 0px;">
      <v-btn  v-on="on" icon><v-icon :size="16">date_range</v-icon></v-btn>
      </div>
    </template>
    <v-date-picker no-title :value="content" @input="updateSelf"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "BookingDateInputSmall",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    error: String,
    old: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    blur() {
      var vm = this;

      setTimeout(function() {
        console.log("Blur " + vm.content);
        vm.$emit("input", vm.content);
      }, 200);
    },
    valid() {
      console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(content) {
      this.menu = false;

      this.content = content;
      this.$emit("submitted");

      this.$emit("input", content);
      console.log("date selected");
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
